module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-anchor-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"datafold.com","short_name":"Datafold","start_url":"/","background_color":"rgba(245,245,245,1)","theme_color":"rgba(245,245,245,1)","display":"minimal-ui","icon":"static/datafold-logo-blue.svg","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"ccfa8389b7511ec6706f371dabb2188f"},
    },{
      plugin: require('../node_modules/gatsby-plugin-segment-js/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"v2AEAMxgLxsQrxTtx532jiUq6ZD5tZce","devKey":"PpXmlhpDbw81ERgsG5P4TynIIRXgCpQ9","trackPage":true,"delayLoad":false,"delayLoadTime":1000},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
